
import { isDark } from '../../state/darkModeState'
import { useStorage, usePreferredDark, useToggle } from '@vueuse/core'
const colorSchema = useStorage('color-schema', 'auto')
const preferredDark = usePreferredDark()
type StepId = 'login' | 'forgot-password'
import ForgotForm from './ForgotForm.vue'

export default {
  name: 'Forgot',
  components:{
    ForgotForm
  },
  setup() {
    
    return {
      isDark
    }

  },
}
